import { useEffect, useState, useRef } from 'react';
export default function useOnScreen(ref) {
    const observerRef = useRef(null);
    const [isOnScreen, setIsOnScreen] = useState(false);
    useEffect(() => {
        if (!ref.current) {
            console.warn('useOnScreen: ref.current is null');
            return;
        }
        const observerCallback = ([entry]) => {
            setIsOnScreen(entry.isIntersecting);
        };
        observerRef.current = new IntersectionObserver(observerCallback, { threshold: 0.1 });
        observerRef.current.observe(ref.current);
        return () => {
            var _a;
            (_a = observerRef.current) === null || _a === void 0 ? void 0 : _a.disconnect();
        };
    }, [ref]);
    return isOnScreen;
}
